import {Button, Text, VStack} from "@chakra-ui/react";
import animationData from "../../../assets/lottie/success_animation.json";
import React from "react";
import Lottie from "lottie-react";
import {useAppDispatch} from "../../../hooks/use-store";
import {changePage, setIsSignup} from "../../../store/reducers";

export const SignupPageSuccess = () => {
    const dispatch = useAppDispatch();

    return <VStack alignContent={"center"}>
        <Lottie loop={false} autoplay animationData={animationData}
                rendererSettings={{preserveAspectRatio: "xMidYMid slice"}} height={200} width={200}/>

        <Text
            color={"tertiary.300"}
            textAlign={"center"}
            fontWeight={"bold"}
            fontSize={"24px"}>La registrazione è andata a buon fine,
            benvenuto!</Text>

        <Text
            color={"black"}
            mt={"16px"}
            textAlign={"center"} fontSize={"20px"}>Effettua il login con le tue nuove credenziali.</Text>

        <Button
            variant={"primary"}
            mt={"24px"}
            onClick={() => {
                dispatch(setIsSignup(false));
                dispatch(changePage(0));
            }}
        >Accedi</Button>
    </VStack>
}
